import { Link } from 'react-router';
import { Box, Button, Container } from '@mui/material';

import type { ButtonBlockContent } from '@/types/database';

const VALID_VARIANTS = new Set(['text', 'outlined', 'contained']);
const VALID_COLORS = new Set(['primary', 'secondary', 'inherit']);

export function ButtonBlockView({ content, basePath }: { content: ButtonBlockContent; basePath: string }) {
  // Tolerant of pre-MUI-prop-alignment rows (old variant values like
  // 'primary'/'outline') — falls back to MUI's own defaults rather than
  // crashing on an invalid prop value.
  const variant = VALID_VARIANTS.has(content.variant ?? '') ? content.variant! : 'contained';
  const color = VALID_COLORS.has(content.color ?? '') ? content.color! : 'primary';
  const link = content.link?.startsWith('/') ? `${basePath}${content.link}` : content.link;

  return (
    <Box sx={{ py: 4 }}>
      <Container maxWidth="md" sx={{ textAlign: 'center' }}>
        <Button component={Link} to={link || '#'} variant={variant} color={color}>
          {content.text}
        </Button>
      </Container>
    </Box>
  );
}
